import React from 'react';
import WimHofImg from '../../imgs/wim_hof_logo.jpg'

const WimHof: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          Wim Hof Fundamentals Workshop
        </h1>
        <div className="flex items-center justify-center bg-lighttan px-4">
            <img
            src={WimHofImg}
            alt="Wim Hof Logo"
            className="w-full md:w-3/4 h-auto rounded-lg shadow-lg object-cover object-center"
            />
        </div>
      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
            Begin or strengthen your Wim Hof Method practice by delving into the breath, the cold, and the proper mindset 
            that comprise the Wim Hof Method.  Sean is a certified Wim Hof Method instructor and trained with Wim Hof himself!
        </p>
      </div>
      <div className="flex justify-center pb-6 md:pb-8 mb-8 md:mb-12 px-4">
        <a
          href="https://calendly.com/seanmotiv8living/wimhofmethodfundamentals?back=1"
          className="px-4 md:px-6 py-2 md:py-3 bg-darkgreentext text-white rounded-lg font-bold text-lg md:text-xl hover:bg-greenbutton transition"
        >
          Sign Up Now
        </a>
      </div>
      
    </div>
  );
};

export default WimHof;
